import { motion } from 'motion/react';

const FadeInMotion = ({
  children,
  keyProp,
  className = '',
  disabled = false,
  duration = 0.25,
  type = 'spring',
  stiffness = 300,
  damping = 30,
  style = {},
  scaleInitial = 0.2,
  scaleFinal = 1,
  opacityInitial = 0,
}) => {
  return (
    <motion.div
      key={keyProp}
      initial={disabled ? false : { opacity: opacityInitial, scale: scaleInitial }}
      animate={disabled ? false : { opacity: 1, scale: scaleFinal }}
      className={className}
      transition={{
        duration,
        scale: { type, stiffness, damping },
      }}
      style={style}>
      {children}
    </motion.div>
  );
};

export default FadeInMotion;
